import Vue from "vue";
import App from "./App";
import router from "./router";

Vue.config.productionTip = false;

import moment from "moment";
moment.locale("en");
Vue.prototype.$moment = moment;

import constPlugin from "./util/constant.js";
Vue.use(constPlugin);

import funcPlugin from "./util/functions.js";
Vue.use(funcPlugin);

Vue.prototype.$sppUrl = "https://spp-api.scancom.net";

//api url from main server
Vue.prototype.$apiUrl = "https://global-api.scancom.net";
import Axios from "axios";
Vue.prototype.$http = Axios.create({
  baseURL: Vue.prototype.$apiUrl,
  timeout: 120000
});

import user from "./store/user.js";
Vue.prototype.$user = user;

import collection from "./store/collection.js";
Vue.prototype.$collection = collection;

import money from "v-money";
Vue.use(money, {
  decimal: ".",
  thousands: ",",
  prefix: "",
  suffix: " USD",
  precision: 0,
  masked: false
});

Vue.prototype.$http.interceptors.request.use(
  config => {
    const userStr = Vue.prototype.$func.getCookie("user-scancom");
    if (userStr) {
      let user = JSON.parse(decodeURI(userStr));
      config.headers["Authorization"] = `Bearer ${user.token}`;
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

import VueSweetalert2 from "vue-sweetalert2";
//If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "static/images/no-photo.svg",
  loading: "static/images/ajax-loader.gif",
  attempt: 1
});

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

new Vue({
  el: "#app",
  router,
  components: { App },
  mounted() {
    if (this.$user.getters.authUser) {
      this.$collection.dispatch("getUserCollection");
    }
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js